export default "__VITE_ASSET__rN3cHEnh__"